import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { BudgetRule, BudgetRuleListResponse, BudgetRuleQueryParams, CreateBudgetRule, UpdateBudgetRule } from '@frontend/budget/types';

export class BudgetRuleClient extends APIClient {
    public static readonly endpoint = '/budget-api/v1';

    public static async fetchBudgetRules(queryParams?: ApiQueryParams<DefaultQueryParams & BudgetRuleQueryParams>): Promise<BudgetRuleListResponse> {
        return await this.apiPaginated<BudgetRuleListResponse, DefaultQueryParams & BudgetRuleQueryParams>(`${this.endpoint}/budget-rules`, queryParams);
    }

    public static async resolveBudgetRules(ids: string[], field: string = 'id'): Promise<BudgetRuleListResponse> {
        return this.resolve<BudgetRuleListResponse>(`${this.endpoint}/budget-rules`, ids, field);
    }

    public static async deleteBudgetRules(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/budget-rules-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postBudgetRule(accountId: string, budgetId: string, body: CreateBudgetRule): Promise<BudgetRule> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/budgets/${budgetId}/rules`, body);
        return await this.handleResponse<BudgetRule>(response);
    }

    public static async fetchBudgetRule(accountId: string, budgetId: string, budgetRuleId: string): Promise<BudgetRule> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/budgets/${budgetId}/rules/${budgetRuleId}`);
        return await this.handleResponse<BudgetRule>(response);
    }

    public static async patchBudgetRule(accountId: string, budgetId: string, budgetRuleId: string, body: UpdateBudgetRule): Promise<BudgetRule> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/budgets/${budgetId}/rules/${budgetRuleId}`, body);
        return await this.handleResponse<BudgetRule>(response);
    }

    public static async deleteBudgetRule(accountId: string, budgetId: string, budgetRuleId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/budgets/${budgetId}/rules/${budgetRuleId}`);
        return await this.handleVoidResponse(response);
    }
}
